import { Component, Input, OnInit } from '@angular/core';
import { CVLocalizationService } from '../../../reusables/services/cv-localization.service';
import { Permissions, GroupTypeDTO, PermissionEmpRecGroup, PermissionEmpGroups, PermissionRecGroups } from '../user-admin.model';
import { UserAdminService } from '../user-admin.service';

@Component({
    selector: 'cv-permissions-useradmin',
    templateUrl: './permissions-useradmin.component.html',
    styleUrls: ['./permissions-useradmin.component.scss']
})
export class PermissionsUseradminComponent implements OnInit {
    @Input() selectedLoginID: number = 0;
    @Input() groupNames: GroupTypeDTO[] = [];

    public localizationDic: Map<string, string> = new Map();
    public permissions: Permissions;
    public showPopup: boolean = false;
    public permission_inner_right_display = [];
    public permission_display: PermissionEmpRecGroup[][][] = [];
    public selectedPermissionModuleID: number = -1;
    public isLoadingPermissionGroupForEmp: boolean = false;
    public isLoadingPermissionGroupForRec: boolean = false;
    public moduleType: { moduleTypeName: string; moduleTypeID: number; }[] = [];
    public moduleTypeRaw: { moduleTypeName: string; moduleTypeID: number; }[] = [
        //custom order to be displayed
        { moduleTypeName: "Stats", moduleTypeID: 0 },
        { moduleTypeName: "Accounts", moduleTypeID: 5 },
        { moduleTypeName: "Quality", moduleTypeID: 1 },
        { moduleTypeName: "Goals", moduleTypeID: 2 },
        { moduleTypeName: "Scheduling", moduleTypeID: 4 },
        { moduleTypeName: "Ranking", moduleTypeID: 6 },
        { moduleTypeName: "Training", moduleTypeID: 3 },
        { moduleTypeName: "Messaging", moduleTypeID: 7 },
    ];

    constructor(
        private uaService: UserAdminService,
        private locService: CVLocalizationService
    ) { }

    ngOnInit(): void {
        this.initAsync();
    }

    async initAsync() {
        this.permissions = await this.uaService.getLoginUserPermissions();
        this.localizationDic = await this.locService.GetSection("Users");
        this.localizeModuleTypes();
        this.reloadPermissionGroup();
    }

    localizeModuleTypes() {
        this.moduleType = [];
        this.moduleTypeRaw.forEach((el) => {
            if (!!this.localizationDic && this.localizationDic.get(el.moduleTypeName) != null) {
                this.moduleType.push({ moduleTypeName: this.localizationDic.get(el.moduleTypeName), moduleTypeID: el.moduleTypeID });
            }
            else {
                this.moduleType.push({ moduleTypeName: el.moduleTypeName, moduleTypeID: el.moduleTypeID });
            }
        });
    }

    canCreateOrWrite(): boolean {
        return this.permissions?.CreateAccess || this.permissions?.WriteAccess;
    }

    async reloadPermissionGroup() {
        this.permission_display = [];
        this.isLoadingPermissionGroupForEmp = true;
        this.isLoadingPermissionGroupForRec = true;

        //Emp Group Info
        let userEGroupInfo: PermissionEmpGroups[][] = await this.uaService.loadUserEmpGroupInfo(this.selectedLoginID);
        for (let i = 0; i < this.moduleType.length; i++) {
            let tmpList: PermissionEmpRecGroup[] = [];
            let tmpList1: PermissionEmpRecGroup[][] = [];
            let tmpGroupName: string = "";
            let id: number = this.moduleType[i].moduleTypeID;

            for (let j = 0; j < userEGroupInfo[id].length; j++) {
                for (let k = 0; k < this.groupNames.length; k++) {
                    if (this.groupNames[k].BaseGroupType == 0 && this.groupNames[k].GroupLevel == userEGroupInfo[id][j].origin.EmpGroupLevel) {
                        tmpGroupName = this.groupNames[k].GroupTypeName;
                        break;
                    }
                }

                let tmp: PermissionEmpRecGroup = {
                    name: userEGroupInfo[id][j].origin.EmpGroupName + " (" + tmpGroupName + ")",
                    GroupName: userEGroupInfo[id][j].origin.EmpGroupName,
                    tree: userEGroupInfo[id][j].chain,
                    type: this.moduleType[i].moduleTypeName,
                    GroupID: userEGroupInfo[id][j].origin.EmpGroupID,
                    GroupLevel: userEGroupInfo[id][j].origin.EmpGroupLevel,
                    GroupSecurityID: userEGroupInfo[id][j].origin.EmpGroupSecurityID,
                    GroupLevelsGranted: userEGroupInfo[id][j].origin.LevelsGranted,
                    Default: userEGroupInfo[id][j].origin.AutomaticCreation,
                    BaseGroupType: '0',
                    ModuleID: id
                };

                tmpList.push(tmp);
            }
            if (userEGroupInfo[id].length == 0) {
                let tmp: PermissionEmpRecGroup = {
                    type: this.moduleType[i].moduleTypeName,
                    ModuleID: id
                }
                tmpList.push(tmp);
            }
            tmpList1.push(tmpList);
            this.permission_display.push(tmpList1);
        }
        this.isLoadingPermissionGroupForEmp = false;

        //Rec Group Info
        let userRGroupInfo: PermissionRecGroups[][] = await this.uaService.loadUserRecGroupInfo(this.selectedLoginID);
            for (let i = 0; i < this.moduleType.length; i++) {
                let tmpList: PermissionEmpRecGroup[] = [];
                let tmpList1: PermissionEmpRecGroup[][] = [];
                let tmpGroupName: string = "";
                let id: number = this.moduleType[i].moduleTypeID;

                for (let j = 0; j < userRGroupInfo[id].length; j++) {
                    for (let k = 0; k < this.groupNames.length; k++) {
                        if (this.groupNames[k].BaseGroupType == 1 && this.groupNames[k].GroupLevel == userRGroupInfo[id][j].origin.RecGroupLevel) {
                            tmpGroupName = this.groupNames[k].GroupTypeName;
                            break;
                        }
                    }

                    let tmp: PermissionEmpRecGroup = {
                        name: userRGroupInfo[id][j].origin.RecGroupName + " (" + tmpGroupName + ")",
                        GroupName: userRGroupInfo[id][j].origin.RecGroupName,
                        tree: userRGroupInfo[id][j].chain,
                        type: this.moduleType[i].moduleTypeName,
                        GroupID: userRGroupInfo[id][j].origin.RecGroupID,
                        GroupLevel: userRGroupInfo[id][j].origin.RecGroupLevel,
                        GroupSecurityID: userRGroupInfo[id][j].origin.RecGroupSecurityID,
                        GroupLevelsGranted: userRGroupInfo[id][j].origin.LevelsGranted,
                        Default: userRGroupInfo[id][j].origin.AutomaticCreation,
                        BaseGroupType: '1',
                        ModuleID: id
                    };
                    tmpList.push(tmp);
                }
                if (userRGroupInfo[id].length == 0) {
                    let tmp: PermissionEmpRecGroup = {
                        type: this.moduleType[i].moduleTypeName,
                        ModuleID: id
                    }
                    tmpList.push(tmp);
                }
                if (!!this.permission_display && i < this.permission_display.length)
                    this.permission_display[i].push(tmpList);
            }
            this.isLoadingPermissionGroupForRec = false;
    }

    editPermission(type: string, ModuleID: number) {
        if (!this.canCreateOrWrite())
            return;

        this.selectedPermissionModuleID = ModuleID;
        this.showPopup = true;
        this.permission_inner_right_display = [];
        for (var i = 0; i < this.permission_display.length; i++) {
            for (var j = 0; j < this.permission_display[i].length; j++) {
                for (var k = 0; k < this.permission_display[i][j].length; k++) {
                    if (this.permission_display[i][j][k].type && this.permission_display[i][j][k].type == type) {
                        if (this.permission_display[i][j][k].name)
                            this.permission_inner_right_display.push(this.permission_display[i][j][k]);
                    }
                }
            }
        }
    }

    async onPermissionSave(data: any[]) {
        if (data.length >= 1) {
            data.forEach((element) => {
                element.ModuleID = this.selectedPermissionModuleID;
                element.Empty = false;
            });
        }
        else {
            var temp = {
                ModuleID: this.selectedPermissionModuleID,
                Empty: true
            }
            data = [];
            data.push(temp);
        }

        await this.uaService.sendUpdatedGroupAssignment(data, this.selectedLoginID, this.selectedPermissionModuleID);
        this.reloadPermissionGroup();
    }
}
